<template>
  <div>
    <masterList :tableColumns="tableColumns" :module="'glvouchers'" :addNew="addNew"></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/finance/gl-voucher/_new",
       tableColumns: [
              {
                prop: 'voucher_code',
                label: 'VOUCHER',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'voucher_date',
                label: 'VOUCHER_DATE',
                minWidth: 180,
                sortable: true,
                key:'VOUCHER_DATE'
              },

              {
                prop: 'reference',
                label: 'REFERENCE',
                minWidth: 180,
                sortable: true,
                key:'REFERENCE'
              },
              {
                prop: 'creator_user_name',
                label: 'USER',
                minWidth: 140,
                sortable: true,
                key:'USER'
              },
              {
                prop: 'is_void_display',
                label: 'VOID',
                minWidth: 140,
                sortable: true,
                key:'VOID'
              },
        ]

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            },

        }

  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>